export default {
    AGUARDANDO_PROCESSAMENTO: 1,
    EM_PROCESSAMENTO: 2,
    PROCESSADO: 3,
    ERRO_NO_PROCESSAMENTO: 4,
}
